import {AppState} from "../RootReducer";

export const getJackpots = (state : AppState) => state.casino.jackpots ?? [];